import { selectHUDState } from '../state/HUDSlice';
import { useSelector } from 'react-redux';

const useHUDactive = () => useSelector(selectHUDState);

export default useHUDactive;
